import { render, staticRenderFns } from "./Citas.vue?vue&type=template&id=64ba6bce"
import script from "./Citas.vue?vue&type=script&lang=js"
export * from "./Citas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports